<template>
  <div class="page">
    <div class="header">
      人脸识别
    </div>
    <div class="title">
      {{ textMsg }}
    </div>

    <div class="btn" v-if="showBtn" @click="toFace()">立 即 核 验</div>
  </div>
</template>

<script>

var obj = require("@/api/api.js");
export default {
  name: "face",
  data() {
    return {
      textMsg: '即将进入人脸识别认证流程，识别认证需保单被保险人操作，识别超过3次则理赔流程失效，需重新查勘理赔，请确认是否继续操作?',
      registno:'',
      showBtn:false
    }
  },
  created() {
    if(this.$route.query.registno){
      this.registno = this.$route.query.registno
      this.showBtn = true
       // this.toFace()
    }else{
      this.textMsg = '无有效业务号'
    }

  },
  methods: {
    toFace() {
      let param = {
        id: '',
        registno: this.registno
      }

      this.$indicator.open({
        text: '请求中...',
        spinnerType: 'double-bounce',
        className:'mintindicator',
      });
      this.$http
        .post(obj.faceUrl, param).then((res) => {
        this.$indicator.close();
        if (res.data.rtnCode == '0000') {
          let _res = res.data.resString
          _res = JSON.parse(_res)
          console.log('session_id', _res.session_id)
          console.log('FACEURL:', _res.verification_url);
          this.$cookie.set('session_id', _res.session_id)

          console.log(this.$cookie.get('session_id'))
          setTimeout(() => {
            window.location.href = _res.verification_url
          }, 2000)
        } else {
          this.showBtn = false
          this.textMsg = res.data.rtnMsg?res.data.rtnMsg:'接口异常，未获取到错误信息'
        }


      });
    },
  }
}
</script>
<style>
body  {
  font-size: 14px !important;
}
</style>
<style lang="scss" scoped>

.page {
  width: 100vw;
  height: 100vh;
  background-color: #f5fffa;

  .header {
    width: 100vw;
    height: 40px;
    background-color: #00a74c;
    text-align: center;
    font-size: 16px;
    line-height: 40px;
    color: white;
  }

  .title {
    width: 80vw;
    height: 60px;
    font-size: 20px;
    text-align: center;
    margin-top: 260px;
    margin-left: 10vw;
  }

  .btn {
    width: 98vw;
    left: 1vw;
    height: 60px;
    background-color: #05c95e;
    text-align: center;
    font-size: 16px;
    line-height: 60px;
    color: white;
    margin-top: 30px;
    border-radius: 5px;
    position: fixed;
    bottom: 60px;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/face/face.vue